import { useState } from "react";

const FormBuilder = () => {
  const [isNewFormModalOpen, setIsNewFormModalOpen] = useState(false);

  return (
    <>
      <div className="tab-panel" data-panel={4}>
        <div className="section-title_user">
          <span>Form Builder</span>
          <div>
            <button
              className="add-button_user"
              onClick={() => setIsNewFormModalOpen(true)}
            >
              <i className="fas fa-plus" /> New Form
            </button>
            <button
              className="add-button_user"
              onclick="importForm()"
              style={{ marginLeft: 10 }}
            >
              <i className="fas fa-file-import" /> Import
            </button>
          </div>
        </div>
        <table className="table">
          <thead>
            <tr>
              <th>Form Name</th>
              <th>Type</th>
              <th>Fields</th>
              <th>Last Modified</th>
              <th>Status</th>
              <th style={{ textAlign: "right" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr data-form-id={1}>
              <td>Patient Intake Form</td>
              <td>Registration</td>
              <td>28</td>
              <td>2025-05-05</td>
              <td>
                <span className="badge active">Active</span>
              </td>
              <td style={{ textAlign: "right" }}>
                <button
                  className="action_icon_btn"
                  title="Design"
                  onclick="designForm(1)"
                >
                  <i className="fas fa-pencil-ruler" />
                </button>
                <button
                  className="action_icon_btn"
                  title="Preview"
                  onclick="previewForm(1)"
                >
                  <i className="fas fa-eye" />
                </button>
                <button
                  className="action_icon_btn"
                  title="Duplicate"
                  onclick="duplicateForm(1)"
                >
                  <i className="fas fa-copy" />
                </button>
                <button
                  className="action_icon_btn"
                  title="Edit"
                  onclick="editForm(1)"
                >
                  <i className="fas fa-edit" />
                </button>
                <button
                  className="action_icon_btn"
                  title="Delete"
                  onclick="deleteForm(1)"
                >
                  <i className="fas fa-trash-alt" />
                </button>
              </td>
            </tr>
            <tr data-form-id={2}>
              <td>PHQ-9 Depression Scale</td>
              <td>Assessment</td>
              <td>9</td>
              <td>2025-04-28</td>
              <td>
                <span className="badge active">Active</span>
              </td>
              <td style={{ textAlign: "right" }}>
                <button className="action_icon_btn" title="Design">
                  <i className="fas fa-pencil-ruler" />
                </button>
                <button className="action_icon_btn" title="Preview">
                  <i className="fas fa-eye" />
                </button>
                <button className="action_icon_btn" title="Duplicate">
                  <i className="fas fa-copy" />
                </button>
                <button className="action_icon_btn" title="Edit">
                  <i className="fas fa-edit" />
                </button>
                <button className="action_icon_btn" title="Delete">
                  <i className="fas fa-trash-alt" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        id="modalNewForm"
        className={`modal_setting ${isNewFormModalOpen ? "active" : ""}`}
      >
        <div className="modal-content_setting">
          <span
            className="close_setting"
            style={{ cursor: "pointer" }}
            onClick={() => setIsNewFormModalOpen(false)}
          >
            ×
          </span>
          <h2>Create New Form</h2>
          <form id="newFormForm">
            <div className="form-row_setting">
              <div>
                <label>Form Name</label>
                <input
                  type="text"
                  id="formName"
                  placeholder="e.g., Patient Intake"
                  required=""
                />
              </div>
              <div>
                <label>Form Type</label>
                <select id="formType" required="">
                  <option value="">Select...</option>
                  <option>Registration</option>
                  <option>Assessment</option>
                  <option>Consent</option>
                  <option>Clinical</option>
                  <option>Administrative</option>
                </select>
              </div>
            </div>
            <label>Description</label>
            <textarea
              id="formDescription"
              placeholder="Brief description of this form's purpose"
              defaultValue={""}
            />
            <div className="form-row_setting">
              <div>
                <label>Category</label>
                <input
                  type="text"
                  id="formCategory"
                  placeholder="e.g., Mental Health"
                />
              </div>
              <div>
                <label>Default Status</label>
                <select id="formStatus" required="">
                  <option value="active">Active</option>
                  <option value="draft">Draft</option>
                </select>
              </div>
            </div>
            <button type="submit" className="add-button_user" style={{alignSelf:'left',marginTop:10,display:'flex'}}>
              Create Form
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default FormBuilder;
